import React from 'react'
import styled from '@emotion/styled'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Paper, Typography } from '@mui/material'

import { ReactComponent as Logo } from '../../vendor/logo.svg'
import ResetPasswordComponent from '../../components/auth/ResetPassword'

const Brand = styled(Logo)`
    fill: ${(props) => props.theme.palette.primary.main};
    width: 64px;
    height: 64px;
    margin-bottom: 32px;
`

const Wrapper = styled(Paper)`
    padding: ${(props) => props.theme.spacing(6)};

    ${(props) => props.theme.breakpoints.up('md')} {
        padding: ${(props) => props.theme.spacing(10)};
    }
`

function ResetPassword() {
    return (
        <React.Fragment>
            <Brand />
            <Wrapper>
                <Helmet title='Glömt lösenord' />

                <Typography component='h1' variant='h4' align='center' gutterBottom>
                    Glömt lösenord
                </Typography>
                <Typography component='h2' variant='body1' align='center'>
                    Skriv in din epostadress för att återställa ditt lösenord
                </Typography>

                <ResetPasswordComponent />
            </Wrapper>
        </React.Fragment>
    )
}

export default ResetPassword
